import styled, { css } from "styled-components";
import Text from "common/Typography/Text";
import { MOBILE_SEARCH } from "common/constants";
import { typography } from "@shared/common/Themes/typography";
import Title from "common/Typography/Title";
import { hexToRGB } from "@shared/utils/misc";
import { newLookType } from "common/NewLook/tokens.ts";
import { CARD_MAX_WIDTH } from "features/configuration/common/constants";
import { phoneMinWidth } from "common/NewLook/layout.ts";

const CardsWrapper = styled.div`
  border-radius: 8px;
  border: ${(p) => p.theme.borders.medium};
  width: 100%;
  max-width: ${CARD_MAX_WIDTH}px;
  height: fit-content;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      overflow: hidden;
      border: ${p.theme.borders.panel};
      border-radius: ${p.theme.radii.card}px;
      background: ${p.theme.colors.cardBgColor};
      box-shadow: ${p.theme.shadows.panel};
    `}
`;

const CardsTitle = styled(Text).attrs({
  $weight: typography.fontWeights.SEMI_BOLD,
  $size: typography.fontSizes.XL,
  as: "div",
})`
  padding: 12px 20px;
  border-bottom: ${(p) => p.theme.borders.lightest};
  @media (max-width: ${MOBILE_SEARCH}) {
    font-size: ${(p) => p.theme.typography.fontSizes.L};
  }
  ${(p) =>
    p.theme.isNewLook &&
    css`
      display: flex;
      align-items: center;
      gap: 12px;
      min-height: 60px;
      padding: 12px 24px;
      color: ${p.theme.colors.titleColor};
      ${newLookType.panelTitle};
      @media (max-width: ${MOBILE_SEARCH}) {
        font-size: 16px;
        padding: 12px 16px;
      }
    `}
`;

const Card = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 90px;
  &:not(:last-of-type) {
    border-bottom: ${(p) => p.theme.borders.lightest};
  }
  padding: 8px 20px;
  ${(p) => p.theme.isNewLook && "padding: 8px 24px;"}
  transition: background-color 0.1s ease-in;
  @media (min-width: ${phoneMinWidth}) {
    &:hover {
      background-color: ${(p) =>
        p.theme.isNewLook
          ? p.theme.colors.cardLightBgColor
          : p.theme.colors.titleCardBgColor};
    }
  }
`;

const GroupImage = styled.img<{ $size?: number }>`
  height: ${(p) => p.$size || 60}px;
  width: ${(p) => p.$size || 60}px;
  border-radius: 8px;
  margin-right: 16px;
  object-fit: cover;
`;

const CardRightSideText = styled(Text).attrs({
  type: "secondary",
})<{ $width?: number }>`
  flex: none;
  ${(p) =>
    p.$width
      ? `
    width: ${p.$width}px;
  `
      : `
    white-space: nowrap;
  `}
`;

export const SecondaryButton = styled(Title).attrs({ level: 4 })`
  text-align: center;
  color: ${(p) => p.theme.colors.primaryBlue};
  cursor: pointer;
  &:hover {
    color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.8)};
  }
`;

export default {
  CardsWrapper,
  CardsTitle,
  Card,
  GroupImage,
  CardRightSideText,
};
